// Attribution: https://mui.com/customization/dark-mode/#main-content

// Material
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const theme = {
	dark: responsiveFontSizes(
		createTheme({
			palette: {
				mode: 'dark',
				type: 'dark',
				primary: {
					main: '#c8102e' //coc burgundy
				},
				secondary: {
					main: '#4b4f55' //coc grey
				}
			},

			components: {
				MuiToolbar: {
					styleOverrides: {
						root: {
							backgroundColor: '#000000',
							color: '#fff'
						}
					}
				},
				MuiTypography: {
					styleOverrides: {
						root: {
							'&.MuiTypography-root': {
								color: '#fff' // white
							}
						}
					}
				},
				MuiSvgIcon: {
					styleOverrides: {
						root: {
							'&:hover': {
								color: '#c8102e' //coc burgundy
							}
						}
					}
				}
			}
		})
	),
	light: responsiveFontSizes(
		createTheme({
			palette: {
				mode: 'light',
				type: 'light',
				primary: {
					main: '#c8102e' //coc burgundy
				},
				secondary: {
					main: '#4b4f55' //coc grey
				},
				// Used by `getContrastText()` to maximize the contrast between
				// the background and the text.
				contrastThreshold: 3,
				// Used by the functions below to shift a color's luminance by approximately
				// two indexes within its tonal palette.
				// E.g., shift from Red 500 to Red 300 or Red 700.
				tonalOffset: 0.2
			},
			components: {
				MuiSvgIcon: {
					styleOverrides: {
						root: {
							'&:hover': {
								color: '#c8102e' //coc burgundy
							}
						}
					}
				}
			}
		})
	)
};

export { theme }